import * as Animate from "react-reveal";
import BundleLogo from "../../../assets/images/png/partner-logo/bundle.png";
import MooveLogo from "../../../assets/images/png/partner-logo/moove.png";
import FlutterwaveLogo from "../../../assets/images/png/partner-logo/flutterwave.png";
import PaystackLogo from "../../../assets/images/png/partner-logo/paystack.png";
import MonoLogo from "../../../assets/images/png/partner-logo/mono.jpeg";
import CowrywiseLogo from "../../../assets/images/png/partner-logo/cowrywise.png";
import TeamaptLogo from "../../../assets/images/png/partner-logo/teamapt.png";
import CredpalLogo from "../../../assets/images/png/partner-logo/credpal.png";
import OpayLogo from "../../../assets/images/png/partner-logo/opay.webp";
import SlackLogo from "../../../assets/images/png/company-logos/slack.png";
import CapitalOneLogo from "../../../assets/images/png/company-logos/capital-one.png";
import GoogleLogo from "../../../assets/images/png/company-logos/google.png";
import AmazonLogo from "../../../assets/images/png/company-logos/amazon.png";
import ShopifyLogo from "../../../assets/images/png/company-logos/shopify.png";
import styles from "./homeCarousel.module.css";

const laneOne = [
  { name: "Bundle", src: BundleLogo },
  { name: "Flutterwave", src: FlutterwaveLogo },
  { name: "Mono", src: MonoLogo },
  { name: "TeamApt", src: TeamaptLogo },
  { name: "Opay", src: OpayLogo },
  { name: "Slack", src: SlackLogo },
  { name: "Capital One", src: CapitalOneLogo },
];

const laneTwo = [
  { name: "Moove", src: MooveLogo },
  { name: "Paystack", src: PaystackLogo },
  { name: "Cowrywise", src: CowrywiseLogo },
  { name: "Credpal", src: CredpalLogo },
  { name: "Google", src: GoogleLogo },
  { name: "Amazon", src: AmazonLogo },
  { name: "Shopify", src: ShopifyLogo },
];

const LogoCard = ({ logo, hidden }) => (
  <div
    className="flex-none w-[180px] md:w-[225px] h-[88px] md:h-[104px] bg-white border border-hire-line rounded-2xl flex items-center justify-center p-5 md:p-6 shadow-course-card"
    aria-hidden={hidden || undefined}
  >
    {logo.src ? (
      <img
        src={logo.src}
        alt={hidden ? "" : logo.name}
        className="max-w-full max-h-full w-auto h-auto object-contain"
      />
    ) : (
      <span className="text-primary font-bold text-sm text-center">
        {logo.name}
      </span>
    )}
  </div>
);

const HomeLogoMarqueeSection = () => {
  return (
    <section className="bg-white py-20 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <Animate.Fade bottom>
          <div className="flex flex-col lg:flex-row lg:justify-between items-end gap-10 mb-10 md:mb-12">
            <div>
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
                <span className="w-8 h-[3px] bg-secondary inline-block"></span>
                Talent in the world
              </p>
              <h2 className="text-primary font-poppins font-bold tracking-[-0.045em] leading-[1.12] text-[30px] md:text-[36px] lg:text-[54px] max-w-xl">
                Our talent works with many of the world&apos;s leading
                companies.
              </h2>
            </div>
            <div className="max-w-md">
              <p className="text-gray text-base font-poppins leading-[1.8] ">
                The Utiva ecosystem reaches beyond the classroom. Professionals
                continue their journeys across global technology, finance,
                consulting and commerce teams.
              </p>
            </div>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="full-bleed overflow-hidden border-y border-hire-line bg-gradient-to-b from-[#fbfcff] to-hire-tint-blue py-6 relative">
            <div
              className={`${styles.carouselContainer} mb-3`}
              aria-label="Companies where Utiva talent works"
            >
              <div
                className={`${styles.carouselRow} ${styles.scrollRight} gap-4 px-4`}
              >
                {[...laneOne, ...laneOne].map((logo, index) => (
                  <div key={`${logo.name}-${index}`} className="pr-0">
                    <LogoCard logo={logo} hidden={index >= laneOne.length} />
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.carouselContainer}>
              <div
                className={`${styles.carouselRow} ${styles.scrollLeft} gap-4 px-4`}
              >
                {[...laneTwo, ...laneTwo].map((logo, index) => (
                  <div key={`${logo.name}-${index}`}>
                    <LogoCard logo={logo} hidden={index >= laneTwo.length} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <p className="flex items-center gap-3 text-primary font-poppins text-sm font-bold leading-relaxed mt-8">
            <span className="bg-secondary text-primary w-11 h-11 rounded-full grid place-items-center text-base font-extrabold flex-none">
              14
            </span>
            recognizable companies. One expanding talent ecosystem.
          </p>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HomeLogoMarqueeSection;
